<template>
	<div class="image-button" @click="$emit('click', $event)">
		<div class="image-button__image" v-if="image"><img :src="image" /></div>
		<div class="image-button__label" v-if="label">{{ label }}</div>
	</div>
</template>

<script>
	import ButtonView from './ButtonView'

	export default {
		extends: ButtonView,
		props: ['image']
	}
</script>

<style lang="scss">
	.image-button {
		position: relative;
		cursor: pointer;
		padding: 0 15px 0 15px;
		display: table;

		&__image {
			vertical-align: middle;
			display: table-cell;
			padding: 0 5px 0 5px;

			& > img {
				display: block;
				width: 32px;
				height: 32px;
				border-radius: 50%;
			}
		}

		&__label {
			display: inline-block;
			display: table-cell;
			vertical-align: middle;
			padding: 0 5px 0 5px;
			white-space: nowrap;
		}
	}
</style>